import type { AgentManifest } from '@indipia/shared';
import { routes } from './src/routes';

// 내 프로필 홍보(ShowroomProfilePage) "시공사례" 탭이 라우트 없이 직접 마운트한다
// (스튜디오 개선 설계서 §9·§11 컴포넌트 마운트 — photo-organizer의 SiteDetailMain과 동일 패턴).
export { ProjectListPage, type ProjectListPageProps } from './src/pages/ProjectListPage';

export const manifest: AgentManifest = {
  agentId: 'portfolio',
  routes,
  menuItems: [
    {
      id: 'portfolio',
      label: '인디포트폴리오',
      icon: 'image',
      path: '/agents/portfolio',
      category: 'common',
      order: 15,
    },
  ],
  permissions: ['OWNER', 'STAFF'],
};
